import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

import {
    Container,
    ContentLight,
    FooterLight,
    HeaderLight,
    Light,
    Line,
    MainLight,
    ParticipantsContent,
    PostForm,
    StrongText,
    TextLight,
    TitleLight,
    UserContent,
    UserImage
} from './styles';

import LevelIcon from 'components/molecules/containers/LevelIcon';
import Button from 'components/molecules/buttons/Button';
import AvatarGroup from 'components/molecules/containers/AvatarGroup';
import CircleGreenButton from 'components/molecules/buttons/CircleGreenButton';

import { getFallbackUrl } from 'utils/general';
import { getSystemImageUrl } from 'utils/assets';
import useFeedback from 'hooks/useFeedback';

import farolVerde from 'assets/images/farol_verde.svg';
import emojiVerde from 'assets/images/emoji_verde.svg';
import farolAmarelo from 'assets/images/farol_amarelo.svg';
import emojiAmarelo from 'assets/images/emoji_amarelo.svg';
import farolVermelho from 'assets/images/farol_vermelho.svg';
import emojiVermelho from 'assets/images/emoji_vermelho.svg';
import subirNivel from 'assets/images/subir_nivel.svg';

import { userType } from 'types/data/user';

const UserAside = ({ user, users }) => {
    const auth = useSelector((state) => state.auth);
    const farol = user?.lighthouse; // Valor poderá ser atualizado futuramente
    const feedback = useFeedback();

    const openPostModal = () => {
        feedback.postForm();
    };

    const farolData = {
        1: {
            image: farolVerde,
            emoji: emojiVerde,
            content: 'Evolução no PFA conforme esperado',
            title: 'Membro engajado!',
            text: 'Continue evoluindo suas competências e habilidades!',
            bgColor: '#87d04d40'
        },
        2: {
            image: farolAmarelo,
            emoji: emojiAmarelo,
            content: 'Evolução no PFA abaixo do esperado',
            title: 'Vamos desenvolver?',
            text: 'Conclua o próximo desafio para subir de nível e desenvolver novas habilidades!',
            bgColor: '#e2b02f33',
            textFooter: 'Você precisa conquistar mais 1 estrela'
        },
        3: {
            image: farolVermelho,
            emoji: emojiVermelho,
            content: 'Evolução no PFA em alerta!',
            title: 'Fique atento!',
            text: 'Conquiste novas estrelas para manter sua permanência na comunidade do PFA.',
            bgColor: '#ce060626',
            textFooter: 'Você precisa conquistar mais 2 estrelas'
        }
    };

    const { image, emoji, content, title, text, bgColor, textFooter } = farolData[farol] || farolData[1];

    return (
        <Container>
            <UserContent>
                <header>
                    <UserImage src={user?.image}>{user?.name?.[0]?.toUpperCase() || ''}</UserImage>
                    <p>Bem vindo ao PFA</p>
                    <h3>{user?.name}</h3>
                </header>

                {user.level && (
                    <main>
                        <LevelIcon level={{ id: user.level.id, name: user.level.level }} small />
                    </main>
                )}

                <footer>
                    <Link to={getFallbackUrl('/aluno/perfil')}>
                        <Button size="fat" width="auto" color="neutral">
                            Perfil
                        </Button>
                    </Link>
                </footer>

                {/* Formulário de postagem */}
                {auth?.user?.enterpriseId && (
                    <PostForm onClick={openPostModal}>
                        <Line />
                        <header>
                            <textarea placeholder="Compartilhe suas ideias:" readOnly />
                        </header>
                        <footer>
                            <CircleGreenButton iconUrl={getSystemImageUrl('Icons_Publicarimage.svg')} />
                            <CircleGreenButton iconUrl={getSystemImageUrl('Icons_Publicarvideo.svg')} />
                            <CircleGreenButton iconUrl={getSystemImageUrl('hashtag.svg')} />
                        </footer>
                    </PostForm>
                )}
            </UserContent>

            {/* Farol de evolução */}
            {farol && (
                <Light bgColor={bgColor}>
                    <HeaderLight>
                        <img src={image} alt="Farol" style={{ width: 24, height: 24 }} />
                        <ContentLight>{content}</ContentLight>
                    </HeaderLight>
                    <MainLight>
                        <img src={emoji} alt="Emoji" style={{ width: 50, height: 50 }} />
                        <TitleLight>{title}</TitleLight>
                        <TextLight>{text}</TextLight>
                    </MainLight>
                    {textFooter && (
                        <FooterLight>
                            <img src={subirNivel} alt="Subir" style={{ width: 46, height: 40 }} />
                            <TextLight>
                                Você precisa conquistar mais <StrongText>{farol === 2 ? '1 estrela' : '2 estrelas'}</StrongText>
                            </TextLight>
                        </FooterLight>
                    )}
                </Light>
            )}

            {/* Participantes */}
            <ParticipantsContent>
                <h3>Participantes do PFA</h3>
                <AvatarGroup users={users} />
                <Link to={getFallbackUrl('/aluno/participantes')}>
                    <Button size="fat" width="auto" color="neutral">
                        Comunidade
                    </Button>
                </Link>
            </ParticipantsContent>
        </Container>
    );
};

UserAside.propTypes = {
    user: PropTypes.shape(userType).isRequired,
    users: PropTypes.arrayOf(PropTypes.shape(userType)).isRequired
};

export default UserAside;
